var _path, _path2, _path3, _circle, _circle2, _circle3, _circle4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCooler(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8033 38.787C38.0592 39.5311 37.0499 39.9492 35.9975 39.9492C34.9452 39.9492 33.9359 39.5311 33.1918 38.787C32.4477 38.0429 32.0296 37.0336 32.0296 35.9813C32.0296 34.9289 32.4477 33.9196 33.1918 33.1755C33.9359 32.4314 34.9452 32.0133 35.9975 32.0133C37.0499 32.0133 38.0592 32.4314 38.8033 33.1755C39.5474 33.9196 39.9655 34.9289 39.9655 35.9813C39.9655 37.0336 39.5474 38.0429 38.8033 38.787Z",
    stroke: "#A80A01",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 36C54 26.0589 45.9411 18 36 18C26.0589 18 18 26.0589 18 36C18 45.9411 26.0589 54 36 54C45.9411 54 54 45.9411 54 36Z",
    stroke: "#A80A01",
    strokeWidth: 2.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4 12H57.6M14.4 12C13.0745 12 12 13.0745 12 14.4M14.4 12H36H57.6M57.6 12C58.9255 12 60 13.0745 60 14.4M60 14.4V57.6M60 14.4V36V57.6M60 57.6C60 58.9255 58.9255 60 57.6 60M57.6 60H14.4M57.6 60H36H14.4M14.4 60C13.0745 60 12 58.9255 12 57.6M12 57.6V14.4M12 57.6V36V14.4",
    stroke: "#A80A01",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.9,
    cy: 53.9,
    r: 1.4,
    stroke: "#A80A01",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9,
    cy: 53.9,
    r: 1.4,
    stroke: "#A80A01",
    strokeWidth: 1.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 53.9,
    cy: 17.9,
    r: 1.4,
    stroke: "#A80A01",
    strokeWidth: 1.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 17.9,
    cy: 17.9,
    r: 1.4,
    stroke: "#A80A01",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCooler);
export default __webpack_public_path__ + "static/media/Cooler.9f680544bfe8b455d93c81cc966125aa.svg";
export { ForwardRef as ReactComponent };